import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { FinancasOffice, markCaseSubmitted } from '../../api/financasOffices';
import FinancasOfficePicker from './FinancasOfficePicker';
import './FinancasOfficePicker.css';

interface SubmitToFinancasDialogProps {
  caseId: string;
  clientName?: string;
  onCancel: () => void;
  onSubmitted: (office: FinancasOffice) => void;
}

// Shown when a lawyer marks a case Submitted and the case has no Finanças
// office yet. Confirming records the office and the status in one request;
// cancelling leaves the case status untouched.
const SubmitToFinancasDialog: React.FC<SubmitToFinancasDialogProps> = ({
  caseId,
  clientName,
  onCancel,
  onSubmitted,
}) => {
  const { currentUser } = useAuth();
  const [office, setOffice] = useState<FinancasOffice | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleConfirm = async () => {
    if (!office || !currentUser) return;
    setSubmitting(true);
    setError('');
    try {
      const token = await currentUser.getIdToken();
      await markCaseSubmitted(token, caseId, office.id);
      onSubmitted(office);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to update the case status.');
      setSubmitting(false);
    }
  };

  return (
    <div className="financas-dialog-backdrop">
      <div
        className="financas-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="financas-dialog-title"
      >
        <h3 id="financas-dialog-title">Mark as Submitted</h3>
        <p>
          Which Finanças office did you file {clientName ? <strong>{clientName}</strong> : 'this case'} at?
        </p>
        <FinancasOfficePicker
          id={`financas-office-select-${caseId}`}
          value={office?.id ?? null}
          valueName={office?.name}
          onChange={setOffice}
          disabled={submitting}
        />
        {error && (
          <div className="status-error-banner" role="alert">{error}</div>
        )}
        <div className="financas-dialog-actions">
          <button type="button" className="financas-btn" onClick={onCancel} disabled={submitting}>
            Cancel
          </button>
          <button
            type="button"
            className="financas-btn financas-btn--primary"
            onClick={handleConfirm}
            disabled={!office || submitting}
          >
            {submitting ? 'Saving...' : 'Mark Submitted'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubmitToFinancasDialog;
